import styles from './sales-offer-product-selection.module.scss';
import { IOfferProductGroup } from '../../_models/offer-product';
import { ChangeEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Row } from 'reactstrap';
import { IProductGroup } from '../../_models/product-group';
import { Card, CardActions, CardContent, Dialog, DialogActions, DialogContent, DialogTitle, GrayOutlinedButton, Icon, List, ListItem, ListItemIcon, ListItemText, SuccessButton, TextField } from '@frontend-workspace/react-shared-lib';
import { InputAdornment } from '@mui/material';
import SalesOfferProductSelectionSkeleton from './sales-offer-product-selection-skeleton';

/* eslint-disable-next-line */
export interface SalesOfferProductSelectionProps {
  open: boolean,
  onClose: () => void,
  onComplete: () => void,
  groups: IOfferProductGroup[]
  onSetCurrentProductGroup: (group: IProductGroup[]) => void,
  onSelectProductGroup: (group: IOfferProductGroup) => void
}

export function SalesOfferProductSelection(props: SalesOfferProductSelectionProps) {
  const { t, i18n } = useTranslation();
  const [filteredGroups, setFilteredGroups] = useState<IOfferProductGroup[]>(props.groups);

  const selectProduct = (group: IOfferProductGroup) => {
    props.onSelectProductGroup(group);
  };

  const search = (e: ChangeEvent<HTMLInputElement>) => {
    if (!e.target?.value) {
      setFilteredGroups(props.groups);
    } else {
      const filteredProducts = props.groups.filter((product) =>
        product.productGroupName.toLowerCase().includes(e.target.value.toLowerCase())
      );
      setFilteredGroups(filteredProducts);
    }
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      maxWidth="lg"
      fullWidth={true}>
      <DialogTitle className='mb-4'>
        {t("shop.productOverview")}
      </DialogTitle>
      <DialogContent>
        <Row>
          <Col>
            <div className='d-flex justify-content-end mb-3'>
              <TextField
                type="search"
                onChange={search}
                placeholder={!props.groups ? '' : t("shop.searchInProducts") || ""}
                InputProps={{
                  startAdornment:
                    <InputAdornment position="start">
                      <Icon>search</Icon>
                    </InputAdornment>
                }}
              />
            </div>
          </Col>
        </Row>
        <Row>
          {filteredGroups.map((product, index) => (
            <Col sm={6} md={6} lg={6} xxl={4} className='col-xxxl-3' key={index}>
              {!props.groups ?
                <SalesOfferProductSelectionSkeleton /> :
                <Card
                  variant="elevation"
                  className="mb-4">
                  <CardContent>
                    <List dense disablePadding>
                      <ListItem disableGutters alignItems="flex-start">
                        <ListItemIcon>
                          <img src={product.iconUrl} alt="" width={40} height={40} className='me-3' />
                        </ListItemIcon>
                        <ListItemText
                          primary={<span className='MuiTypography-body2' title={product.productGroupName}>{product.productGroupName}</span>}
                          secondary={<span className='MuiTypography-body3'>{`${product.numberOfProducts} ${t('standard.products')}`}</span>} />
                      </ListItem>
                    </List>
                  </CardContent>
                  <CardActions className='d-flex justify-content-between pt-0 '>
                    <SuccessButton
                      variant="contained"
                      fullWidth
                      onClick={() => selectProduct(product)}>
                      <Icon className="me-1" fontSize="small">add</Icon>{t("shop.add")}
                    </SuccessButton>
                  </CardActions>
                </Card>
              }
            </Col>
          ))}
        </Row>
      </DialogContent>
      <DialogActions>
        <GrayOutlinedButton
          variant="outlined"
          size='large'
          onClick={props.onClose}
          className='minButtonWidth'>
          {t("standard.cancel")}
        </GrayOutlinedButton>
      </DialogActions>
    </Dialog>
  );
}

export default SalesOfferProductSelection;
